<div class="columns is-vcentered is-centered">
    <div class="column">
        <img src="assets/version2/loginBanner.jpg" style="box-shadow:-20px 20px 0px 0px #5181FF; border-radius: 20px 20px 20px 20px;" alt="">
    </div>
    <div class="column">
        <div class="heading title is-2">Welcome Back</div>
        <div class="subHeading title is-6">Login to manage your account.</div>
        <div class="loginFormCls">
            <form [formGroup]="form" id="loginform">
                <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form">
                </formly-form>
            </form>
            <div class="loginCnt">
                <span [ngStyle]="{'visibility': (config.hideSignUp)? 'hidden': 'initial'}">Don't have an account? <a
                        href="javascript:void(0);" routerLink="{{config.signup}}" style="font-size: 15px;font-weight: bold;">Signup</a></span>

                <!-- <div class="buttonCnt">
                    <button class="section-header button transparent-button" (click)="loginClicked()"
                        form="loginform">{{'LblLogin'|translate}}</button>
                </div> -->
            </div>
        </div>
        <div>
            <button class="joinMeeting" 
             (click)="loginAction()"
            form="loginform" style="margin-top: 2px;">{{'LblLogin'|translate}}</button><br>
            <button class="joinMeeting" style="margin-top: 10px;" (click)="navigateToJoinMeeting()">{{'LblJoinMeeting'|translate}}</button>
        </div>
    </div>
</div>
<p-dialog header="Authentication" [(visible)]="showAuthenticationPopup" styleClass="notesdialogCls" [baseZIndex]="10000" [modal]="isModal">
    <label>Please select any one of the Authentication Method.</label><br>
    <form>
        <div style="margin-top: 40px;">
            <p-radioButton name="groupname" value="email" label="Send OTP on Email" [(ngModel)]="selectedValue" inputId="1" (click)="checkBoxChecked('email')"></p-radioButton>
            <label>({{userEmail}})</label><br>
            <p-radioButton name="groupname" value="sms" label="Send OTP on Mobile"  [(ngModel)]="selectedValue" inputId="2" (click)="checkBoxChecked('sms')"></p-radioButton>
            <label>({{userMobile}})</label><br>
            <p-radioButton name="groupname" value="call" label="Send OTP over voice Call"  [(ngModel)]="selectedValue" inputId="3" (click)="checkBoxChecked('call')"></p-radioButton>
            <label>({{userMobile}})</label>
        </div>
        <button style="margin-top: 30px;" class="section-header button transparent-button" (click)="sendOtp()">{{'LblSendOtp'|translate}}</button>
    </form>
    
    
</p-dialog>
<p-dialog header="Verify OTP" [(visible)]="showVerifyOTPPopup" styleClass="notesdialogCls" [baseZIndex]="10000" [modal]="isModal">
    <label>Please enter the OTP</label><br>
    <form>
        <div style="margin-top: 40px;">
            <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{length:4}"></ng-otp-input>
            <!-- <span *ngIf="timer > 0">Resend OTP in {{ timer }} seconds</span> -->
        </div>
        <button style="margin-top: 30px;" class="section-header button transparent-button" (click)="loginClicked()">{{'LblVerifyOtp'|translate}}</button>
        <button style="margin-top: 30px; margin-left: 20px;" class="section-header button transparent-button" (click)="sendOtp()">{{'LblReSendOtp'|translate}}</button>
    </form>
    
    
</p-dialog>